module.exports = __webpack_public_path__ + "img/hr-dry-dirt-transition.7894ae44.png";